// 20 kindness challenges with category, hero image, and step-by-step instructions.

const IMG = {
  // Authentic SCL classroom + community photos
  community: "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/7fc87vsh_kates%20class%206.jpeg", // SCL students on school steps showing handmade bags
  outdoor:   "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/mbtyjnbz_PXL_20251106_154523113.webp", // SCL kids cleaning up the yard with a wheelbarrow full of sticks
  soccer:    "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/m5dei8je_nicks%20class%206.jpeg", // SCL kids playing soccer at a neighborhood park
  reading:   "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/vjq2mw81_20250425_145626.webp", // SCL teacher reading a book with a young student
  creative:  "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/hxkwobdc_IMG_1720.webp", // SCL students drawing quietly on the classroom carpet
  food:      "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/7i4foipx_FullSizeRender%20%282%29.jpg", // SCL kids in aprons cooking together
  meal:      "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/rjj10oru_PXL_20260521_190424924.webp", // SCL kids and staff sharing a meal around the table
  helping:   "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/v52xcsw8_PXL_20260521_140549265.webp", // SCL kids helping each other on the lawn
  teaching:  "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/u9tpi7kv_IMG_0013.webp", // (unused) chess learning photo — reserved
  peer_teach: "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/qt74mb0q_IMG_1598.webp", // Two SCL PreK kids helping each other with a math worksheet
  letters:   "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/x4w0ylzw_Owen%27s%20Phone%205-7%20096.webp", // SCL kids writing in journals together on the reading rug
  garden:    "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/qj5r9o5x_20250410_113353.webp", // SCL intergenerational planting — elder + kids working with soil and seedlings
  garden_alt: "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/wk1saez0_PXL_20260526_150353258.webp", // (unused) community garden pea vines — reserved
  performance: "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/zv0gvnud_kates%20class%208.jpeg", // SCL kids performing on stage with microphones
  community_event: "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/m3wxgjts_IMG_20211001_130900.webp", // (unused) SCL kids at an Indianapolis Indians game
  community_drive: "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/riudi6pw_20250410_114411.webp", // SCL kids receiving potting mix from a Witherspoon Presbyterian partner van
  family_dinner: "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/e5sft9z1_IMG_4675.webp", // (unused) SCL family gala dinner
  service:   "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/wbadazqy_IMG_3843.webp", // SCL students building — sawing wood together at picnic tables outdoors
  workshop:  "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/zxsqf6j2_IMG_3838.webp", // (reserved) SCL teens loading wood in a workshop
  creek:     "https://customer-assets-0z36b82j.emergentagent.net/job_scl-kindness/artifacts/0d70okya_IMG_4553.webp", // (reserved) SCL kids exploring a creek in the woods
};

export const CHALLENGES = [
  {
    id: 1, title: "Write an encouraging note for a stranger",
    age: "All Ages", difficulty: "Easy", points: 25, category: "creative", image: IMG.creative,
    description: "Grab a sticky note, write something kind, and leave it somewhere a stranger will find it. Small words go a long way.",
    steps: [
      "Grab a sticky note, index card, or scrap of paper.",
      "Write something warm and specific — 'You matter,' 'Someone's rooting for you,' or a short compliment.",
      "Leave it somewhere public — a library book, a coffee shop table, a bathroom mirror.",
      "Take a quick photo before you drop it off.",
    ],
  },
  {
    id: 2, title: "Pick up litter in your neighborhood for 10 minutes",
    age: "All Ages", difficulty: "Easy", points: 30, category: "outdoor", image: IMG.outdoor,
    description: "Grab a bag and clean up a block. Your neighborhood — and everyone who walks it — will thank you.",
    steps: [
      "Grab a trash bag and (if you have them) gloves.",
      "Pick a block, sidewalk, or park path.",
      "Fill your bag for at least 10 minutes.",
      "Snap a before/after photo of the spot.",
    ],
  },
  {
    id: 3, title: "Compliment 3 people you don't know today",
    age: "All Ages", difficulty: "Easy", points: 25, category: "community", image: IMG.community,
    description: "A cashier, a neighbor, a classmate. Notice something real and say it out loud.",
    steps: [
      "Look for something genuine — their outfit, their kindness, their smile.",
      "Say it with eye contact and mean it.",
      "Do it three times before the day is out.",
      "Snap a selfie or short video sharing how it felt.",
    ],
  },
  {
    id: 4, title: "Help a neighbor with groceries or hold a door",
    age: "All Ages", difficulty: "Easy", points: 25, category: "helping", image: IMG.helping,
    description: "Look for a small chance to help someone today. Offer before they ask.",
    steps: [
      "Keep your eyes open — someone with heavy bags, a stroller, a walker.",
      "Ask kindly: 'Can I give you a hand?'",
      "Help without needing anything in return.",
      "Snap a picture of the setting (not the person if they don't want it).",
    ],
  },
  {
    id: 5, title: "Draw a thank-you card for a teacher or librarian",
    age: "PreK-2", difficulty: "Easy", points: 30, category: "creative", image: IMG.creative,
    description: "Grab crayons and make a card for someone who works hard for you. Deliver it in person if you can.",
    steps: [
      "Fold a piece of paper in half to make a card.",
      "Draw something colorful and write 'Thank you' inside.",
      "Deliver it in person or leave it on their desk.",
      "Take a picture of your finished card.",
    ],
  },
  {
    id: 6, title: "Share your snack or lunch with someone who needs it",
    age: "PreK-2", difficulty: "Easy", points: 25, category: "food", image: IMG.meal,
    description: "See a friend without a snack? Share yours. Kindness starts at the lunch table.",
    steps: [
      "Notice someone at your table who could use a bite.",
      "Offer to share — no big deal, just kind.",
      "Sit and eat together.",
      "Snap a photo of the shared snack (or a selfie together).",
    ],
  },
  {
    id: 7, title: "Read aloud to a younger sibling for 15 minutes",
    age: "K-3", difficulty: "Easy", points: 35, category: "reading", image: IMG.reading,
    description: "Pick a favorite book and read it with feeling. Little ones remember these moments forever.",
    steps: [
      "Pick a book you love or one they love.",
      "Use different voices for the characters — go big.",
      "Read for at least 15 minutes with your whole attention.",
      "Snap a photo of the two of you (or the open book).",
    ],
  },
  {
    id: 8, title: "Donate 5 items to a shelter or food pantry",
    age: "All Ages", difficulty: "Medium", points: 50, category: "helping", image: IMG.helping,
    description: "Go through your closet or pantry. Pick 5 things in good shape and drop them off at a local shelter.",
    steps: [
      "Find 5 items in good condition you no longer need.",
      "Bag them together neatly.",
      "Drop them at a local shelter, pantry, or donation bin.",
      "Snap a photo of the bag before or after drop-off.",
    ],
  },
  {
    id: 9, title: "Organize a small cleanup at a park or community space",
    age: "3rd-8th", difficulty: "Medium", points: 60, category: "outdoor", image: IMG.outdoor,
    description: "Rally a friend or two, grab gloves and bags, and give a public space some love.",
    steps: [
      "Invite 1-3 friends or family members.",
      "Pick a park, playground, or block that needs love.",
      "Bring gloves, bags, and water — spend 30-60 minutes.",
      "Take a group photo with the collected trash bags.",
    ],
  },
  {
    id: 10, title: "Bake or make something and share with a neighbor",
    age: "All Ages", difficulty: "Medium", points: 50, category: "food", image: IMG.food,
    description: "Cookies, banana bread, a hand-drawn picture — bring it over with a smile.",
    steps: [
      "Bake or make something homemade.",
      "Wrap it nicely — parchment, ribbon, a card.",
      "Walk it over to a neighbor's door.",
      "Snap a photo of what you made before delivery.",
    ],
  },
  {
    id: 11, title: "Write letters to seniors at a local care home",
    age: "3rd-8th", difficulty: "Medium", points: 60, category: "creative", image: IMG.letters,
    description: "A handwritten letter can make someone's whole week. Write with care and drop them off.",
    steps: [
      "Write 3-5 short handwritten letters (any topic, warm tone).",
      "Sign your first name only.",
      "Call a nearby care home and ask if you can drop them off.",
      "Take a picture of the finished stack of letters.",
    ],
  },
  {
    id: 12, title: "Teach a younger kid something you're good at",
    age: "K-5", difficulty: "Medium", points: 50, category: "learning", image: IMG.peer_teach,
    description: "Basketball? Braiding? A math trick? Share what you know with someone who looks up to you.",
    steps: [
      "Pick one skill you actually enjoy.",
      "Break it into small steps — teach patiently.",
      "Practice with them for at least 15 minutes.",
      "Snap a photo or short video of the mini-lesson.",
    ],
  },
  {
    id: 13, title: "Create a kindness kit and gift it to someone",
    age: "All Ages", difficulty: "Medium", points: 55, category: "creative", image: IMG.creative,
    description: "Fill a small bag with notes, snacks, and little goodies. Give it to a friend, teacher, or stranger who needs it.",
    steps: [
      "Find a small bag or box.",
      "Fill it with 3-5 items: a note, a snack, a small treat, a sticker.",
      "Give it to someone who could use a lift.",
      "Snap a photo of the finished kit before handing it off.",
    ],
  },
  {
    id: 14, title: "Start a gratitude wall in your school or home",
    age: "All Ages", difficulty: "Medium", points: 50, category: "creative", image: IMG.creative,
    description: "Put up sticky notes where people can write what they're grateful for. Watch it grow.",
    steps: [
      "Pick a wall, fridge, or corkboard.",
      "Post a sign: 'What are you grateful for today?'",
      "Leave sticky notes and pens nearby.",
      "Snap a photo of the wall (empty and full, if you can).",
    ],
  },
  {
    id: 15, title: "Help an elderly person with tech or chores for 30 minutes",
    age: "5th-8th", difficulty: "Go Big", points: 100, category: "helping", image: IMG.garden,
    description: "Set up a phone, take out the trash, water plants. Real help, real time, real kindness.",
    steps: [
      "Ask a family member, neighbor, or care home if they need help.",
      "Show up on time and be patient — no rushing.",
      "Help with tech, chores, or errands for 30+ minutes.",
      "Snap a respectful photo of the setting (not their face if they'd rather not).",
    ],
  },
  {
    id: 16, title: "Organize a neighborhood kindness drive",
    age: "5th-8th", difficulty: "Go Big", points: 150, category: "community", image: IMG.community_drive,
    description: "Collect books, clothes, or food from neighbors. Deliver it to a place that needs it.",
    steps: [
      "Pick what to collect (books, clothes, non-perishable food).",
      "Make flyers or a group text — set a drop-off date.",
      "Collect from neighbors for a few days.",
      "Deliver together and take a group photo with the haul.",
    ],
  },
  {
    id: 17, title: "Lead a kindness activity at school or morning meeting",
    age: "5th-8th", difficulty: "Go Big", points: 125, category: "community", image: IMG.performance,
    description: "Plan a 10-minute activity or talk. Get your class involved. Ideas travel further than one person.",
    steps: [
      "Ask your teacher for 10 minutes.",
      "Plan a short activity — a game, a talk, a challenge.",
      "Lead it and get everyone participating.",
      "Snap a photo or short video of the group (with permission).",
    ],
  },
  {
    id: 18, title: "Make a video or poster about kindness and share it",
    age: "3rd-8th", difficulty: "Go Big", points: 100, category: "creative", image: IMG.creative,
    description: "Make something you're proud of and put it out into the world. Inspire people you'll never meet.",
    steps: [
      "Brainstorm a message — one kindness idea worth sharing.",
      "Make a poster, short video, or reel.",
      "Post it on social or hang it up in your school/neighborhood.",
      "Save a screenshot or photo of the finished piece.",
    ],
  },
  {
    id: 19, title: "Volunteer at a community event for 2+ hours",
    age: "5th-8th", difficulty: "Go Big", points: 150, category: "community", image: IMG.service,
    description: "Sign up, show up, and help. Two hours can change how you see your city.",
    steps: [
      "Find a local event that needs volunteers.",
      "Sign up and show up on time.",
      "Give at least 2 focused hours of help.",
      "Snap a photo at the event (a sign, your volunteer badge, or a group shot).",
    ],
  },
  {
    id: 20, title: "Partner up for 3 acts of kindness in one day",
    age: "All Ages", difficulty: "Go Big", points: 125, category: "community", image: IMG.soccer,
    description: "Pick a partner, pick 3 acts, do them together. Kindness is even better when it's shared.",
    steps: [
      "Pick a friend, sibling, or family member as your partner.",
      "Choose 3 quick acts — small ones count.",
      "Do all 3 together in one day.",
      "Take one photo per act (or a single photo collage).",
    ],
  },
];

export const WHEEL_COLORS = [
  "#F08C5D", "#2E5E5C", "#F4C94E", "#B14A3A",
  "#F08C5D", "#2E5E5C", "#F4C94E", "#B14A3A",
];

export const DIFFICULTY_STYLES = {
  "Easy":   { bg: "bg-[#2E5E5C]", text: "text-white", ring: "ring-[#2E5E5C]" },
  "Medium": { bg: "bg-[#F4C94E]", text: "text-[#2B2A28]", ring: "ring-[#F4C94E]" },
  "Go Big": { bg: "bg-[#B14A3A]", text: "text-white", ring: "ring-[#B14A3A]" },
};

export function challengeById(id) {
  return CHALLENGES.find((c) => c.id === Number(id));
}
